import React, { memo, useCallback, useState } from 'react'

import { Button, Icon, Refresh } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, bool, func, number, shape, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import ImageLightbox from 'Pods/ThreeDStudio/Shared/ImageLightbox/ImageLightbox'

const regenerateIcon = <Icon svgComponent={Refresh} size={iconSize} notSpaced />

// Completed turn that returned several variations. Only Regenerate sits under the grid,
// since it acts on the whole set; every per-image action lives in the lightbox a tile opens.
function ResultGrid({ results, isGenerating, onApply, onRegenerate, onEdit }) {
  const t = useTranslation()
  const [openedResult, setOpenedResult] = useState(null)

  const handleCloseLightbox = useCallback(() => setOpenedResult(null), [])

  return (
    <>
      <div className="image-assistant-create-tab__result-grid">
        <div className="image-assistant-create-tab__result-grid-images">
          {results.map(result => (
            <button
              key={result.id}
              type="button"
              className="image-assistant-create-tab__result-grid-button"
              aria-label={t('imageAssistantPanel.createTab.result.expand')}
              onClick={() => setOpenedResult(result)}
            >
              <img className="image-assistant-create-tab__result-grid-image" src={result.url} alt={result.alt} />
            </button>
          ))}
        </div>
        <div className="image-assistant-panel__actions">
          <Button
            type="secondary"
            size="small"
            variant="with-icon"
            customClass="image-assistant-panel__action"
            icon={regenerateIcon}
            disabled={isGenerating}
            onClick={onRegenerate}
          >
            {t('imageAssistantPanel.actions.regenerate')}
          </Button>
        </div>
      </div>
      {openedResult && (
        <ImageLightbox
          result={openedResult}
          isGenerating={isGenerating}
          onApply={() => onApply(openedResult)}
          onRegenerate={onRegenerate}
          onEdit={() => onEdit(openedResult)}
          onClose={handleCloseLightbox}
        />
      )}
    </>
  )
}

ResultGrid.propTypes = {
  results: arrayOf(shape({ id: number, url: string, alt: string })).isRequired,
  isGenerating: bool.isRequired,
  onApply: func.isRequired,
  onRegenerate: func.isRequired,
  onEdit: func.isRequired,
}

export default memo(ResultGrid)
